export interface Category {
  id: string;
  name: string;
  url: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sneakers%20collection%20on%20minimalist%20white%20marble%20surface%2C%20luxury%20fashion%20photography%2C%20clean%20editorial%20style%20with%20soft%20natural%20lighting%2C%20high-end%20product%20photography%20showcasing%20multiple%20designer%20shoes%20arranged%20elegantly&width=600&height=600&seq=cat-shoes&orientation=squarish'
  },
  {
    id: 'hoodies',
    name: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20streetwear%20hoodies%20and%20sweaters%20flat%20lay%20on%20warm%20beige%20fabric%20background%2C%20fashion%20editorial%20photography%20with%20soft%20natural%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20high-end%20clothing%20product%20photography&width=600&height=600&seq=cat-hoodies&orientation=squarish'
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirts%20collection%20stacked%20neatly%20on%20white%20background%2C%20fashion%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20minimalist%20aesthetic%2C%20high-end%20streetwear%20brand%20photography&width=600&height=600&seq=cat-tshirts&orientation=squarish'
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20designer%20jackets%20and%20outerwear%20hanging%20on%20minimalist%20wooden%20rack%2C%20fashion%20editorial%20photography%20with%20warm%20natural%20lighting%2C%20clean%20luxury%20aesthetic%2C%20high-end%20streetwear%20product%20photography%20on%20neutral%20background&width=600&height=600&seq=cat-jackets&orientation=squarish'
  },
  {
    id: 'pants',
    name: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20designer%20pants%20and%20shorts%20flat%20lay%20on%20clean%20white%20background%2C%20fashion%20product%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20high-end%20streetwear%20clothing%20photography%20with%20subtle%20shadows&width=600&height=600&seq=cat-pants&orientation=squarish'
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20caps%20and%20beanies%20collection%20arranged%20on%20minimalist%20wooden%20surface%2C%20fashion%20editorial%20photography%20with%20soft%20warm%20lighting%2C%20clean%20streetwear%20aesthetic%2C%20high-end%20accessory%20product%20photography%20on%20neutral%20beige%20background&width=600&height=600&seq=cat-headwear&orientation=squarish'
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20matching%20outfit%20sets%20laid%20out%20flat%20on%20clean%20white%20background%2C%20coordinated%20clothing%20collection%20photography%20with%20soft%20natural%20lighting%2C%20fashion%20editorial%20style%2C%20minimalist%20luxury%20aesthetic%20product%20photography&width=600&height=600&seq=cat-sets&orientation=squarish'
  },
  {
    id: 'underwear',
    name: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20underwear%20collection%20neatly%20folded%20on%20clean%20white%20linen%20background%2C%20minimalist%20fashion%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20editorial%20style%2C%20high-end%20apparel%20photography%20with%20subtle%20warm%20tones&width=600&height=600&seq=cat-underwear&orientation=squarish'
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20sports%20jerseys%20collection%20hanging%20on%20minimalist%20rack%2C%20fashion%20editorial%20photography%20with%20soft%20natural%20lighting%2C%20clean%20streetwear%20aesthetic%2C%20high-end%20sportswear%20product%20photography%20on%20neutral%20light%20gray%20background&width=600&height=600&seq=cat-jersey&orientation=squarish'
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20fashion%20accessories%20collection%20including%20sunglasses%20watches%20jewelry%20arranged%20on%20marble%20surface%2C%20luxury%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20minimalist%20editorial%20style%20on%20warm%20neutral%20background&width=600&height=600&seq=cat-accessories&orientation=squarish'
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20designer%20handbags%20and%20backpacks%20collection%20on%20clean%20white%20background%2C%20luxury%20fashion%20product%20photography%20with%20soft%20natural%20lighting%2C%20editorial%20style%20arrangement%2C%20high-end%20accessory%20photography%20with%20subtle%20shadows&width=600&height=600&seq=cat-bags&orientation=squarish'
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20collection%20coiled%20neatly%20on%20warm%20wooden%20surface%2C%20fashion%20accessory%20product%20photography%20with%20soft%20natural%20lighting%2C%20clean%20minimalist%20editorial%20style%2C%20high-end%20luxury%20leather%20goods%20photography&width=600&height=600&seq=cat-belts&orientation=squarish'
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20collection%20on%20marble%20surface%20with%20soft%20natural%20lighting%2C%20luxury%20beauty%20product%20photography%20in%20clean%20editorial%20style%2C%20minimalist%20aesthetic%20with%20warm%20neutral%20tones%2C%20high-end%20fragrance%20product%20photography&width=600&height=600&seq=cat-perfumes&orientation=squarish'
  },
  {
    id: 'other',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20lifestyle%20products%20collection%20arranged%20on%20clean%20white%20background%2C%20fashion%20editorial%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20aesthetic%20showing%20various%20luxury%20goods%2C%20high-end%20product%20photography%20with%20subtle%20shadows&width=600&height=600&seq=cat-other&orientation=squarish'
  }
];

export const mainSiteUrl = 'https://kaspreadsheet.com';